/**
 * Tool-mode lookup tables for the SR editor tunnel.
 *
 * Maps the active toolbar tool id to the note/wall it places, and groups the
 * tool ids by category (rail / note / obstacle). Pure data extracted from
 * TunnelScene so placement logic and these tables can evolve independently.
 */

/** Tool id → note type + hand for note/rail placement tools. */
export const TOOL_TO_NOTE: Record<string, { note_type: string; hand: 'right' | 'left' | 'special' }> = {
  note_right:     { note_type: 'right_hand',         hand: 'right' },
  note_left:      { note_type: 'left_hand',          hand: 'left' },
  note_onehand:   { note_type: 'one_hand_special',   hand: 'special' },
  note_bothhands: { note_type: 'both_hands_special',  hand: 'special' },
  rail_right:     { note_type: 'right_hand',         hand: 'right' },
  rail_left:      { note_type: 'left_hand',          hand: 'left' },
  rail_onehand:   { note_type: 'one_hand_special',   hand: 'special' },
  rail_bothhands: { note_type: 'both_hands_special',  hand: 'special' },
};

/** Tool id → obstacle wall_type for obstacle placement tools. */
export const TOOL_TO_WALL_TYPE: Record<string, string> = {
  wall_left:      'wall_left',
  wall_right:     'wall_right',
  wall_diag_left: 'angle_left',
  wall_diag_right:'angle_right',
  wall_center:    'center',
  crouch:         'crouch',
};

export const RAIL_TOOL_MODES = new Set(['rail_right', 'rail_left', 'rail_onehand', 'rail_bothhands']);
export const NOTE_TOOL_MODES = new Set([
  'note_right', 'note_left', 'note_onehand', 'note_bothhands',
  'rail_right', 'rail_left', 'rail_onehand', 'rail_bothhands',
]);
export const OBSTACLE_TOOL_MODES = new Set([
  'wall_left', 'wall_right', 'wall_diag_left', 'wall_diag_right', 'wall_center', 'crouch',
]);

/** The eight walls a Synth VR wall button or hotkey places (SRVR-0313): the five slide `wall_type`s,
 *  the crouch, and the square and triangle. */
export type WallKind = 'wall_left' | 'wall_right' | 'angle_left' | 'angle_right' | 'center' | 'crouch' | 'square' | 'triangle';

/**
 * Wall tool id → the wall its Synth VR button places. In the VR editor these ids are never a tool
 * mode: the Obstacles panel's buttons, and the keys that used to select them, call
 * `toggleWallAtPlayhead` with this kind instead (SRVR-0313). The Console editor still selects them.
 */
export const TOOL_TO_WALL_KIND: Record<string, WallKind> = {
  wall_left: 'wall_left', wall_right: 'wall_right',
  wall_diag_left: 'angle_left', wall_diag_right: 'angle_right',
  wall_center: 'center', crouch: 'crouch',
  wall_square: 'square', wall_triangle: 'triangle',
};
